import { InvoiceReportsTable } from '@/features/invoice_reports/components/List/Table/Table';
import { useNetworkStatus } from '@/hooks/useNetworkStatus';
import { FC, memo, useMemo } from 'react';

export const LoadingInvoiceReportsTable: FC = memo(() => {
  const isOnline = useNetworkStatus();
  const pagination = useMemo(
    () => ({
      currentPage: 1,
      maxPage: 1,
      perPage: 1,
      maxRecord: 0,
    }),
    []
  );
  const tableProps = useMemo(
    () => ({ data: [], loading: isOnline }),
    [isOnline]
  );
  return (
    <InvoiceReportsTable
      table={tableProps}
      pagination={pagination}
      isSearchEmpty={false}
    />
  );
});
LoadingInvoiceReportsTable.displayName = 'LoadingInvoiceReportsTable';
